import { AsyncPipe, DatePipe, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { Angulartics2Segment } from 'angulartics2';
import { Observable } from 'rxjs';

import { A11yModule } from '@angular/cdk/a11y';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { IManagerSpecialRequest } from '@shared/shared/interfaces/manager-special-request.interfaces';
import { ManagerSpecialRequestService } from '@shared/shared/services/manager-special-request.service';

@Component({
  selector: 'ten-request-dialog',
  templateUrl: './request-dialog.component.html',
  styleUrls: ['./request-dialog.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    TranslateModule,
    AsyncPipe,
    MatDividerModule,
    MatLegacyFormFieldModule,
    MatLegacySelectModule,
    MatLegacyOptionModule,
    MatLegacyInputModule,
    MatDatepickerModule,
    MatIconModule,
    MatLegacyDialogModule,
    MatLegacyButtonModule,
    A11yModule,
    MatLegacyProgressSpinnerModule,
  ],
})
export class RequestDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public innerWidth: number;
  public startDate: any;
  public requestSubmitting = false;
  public requestSubmitted = false;
  public readonly customisableVariables: Observable<CustomisableVariables> =
    this.customisableVariablesService.variables;

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<RequestDialogComponent>,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private angulartics2Segment: Angulartics2Segment,
    private customisableVariablesService: CustomisableVariablesService,
    private managerSpecialRequestService: ManagerSpecialRequestService
  ) {
    // Form
    this.form = fb.group({
      type: ['', Validators.required],
      date: ['', Validators.required],
      detail: ['', Validators.required],
    });

    this.startDate = new Date();
  }

  public closeDialog() {
    this.updateRequestReset();

    this.form = this.fb.group({
      type: ['', Validators.required],
      date: ['', Validators.required],
      detail: ['', Validators.required],
    });

    this.startDate = new Date();
    this.form.markAsPristine();
    this.dialogRef.close();
  }

  public ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  /*
    Submit manager special request
  */
  public sendRequest() {
    this.requestSubmitting = true;
    const managerSpecialRequestData: IManagerSpecialRequest = {
      type: this.form.value.type,
      date_selected: this.datePipe.transform(this.form.value.date, 'yyyy-MM-dd'),
      message: this.form.value.detail,
    };

    this.managerSpecialRequestService.createManagerSpecialRequest(managerSpecialRequestData).subscribe(
      () => this.updateRequestSuccess(),
      () => this.updateRequestReset()
    );

    // Notify Segment.io.
    this.notifySegment(this.form.value.type, this.form.value.date);
  }

  @HostListener('window:resize', ['$event'])
  public onResize() {
    this.innerWidth = window.innerWidth;
  }

  /**
   * Notify Segment.io that user sent a custom concierge request.
   */
  private notifySegment(type: string, date: string) {
    this.angulartics2Segment.eventTrack('Custom Request Submitted', {
      customRequestType: type,
      customRequestDate: date,
    });
  }

  private updateRequestSuccess() {
    this.requestSubmitting = false;
    this.requestSubmitted = true;
    this.cdr.detectChanges();
  }

  private updateRequestReset() {
    this.requestSubmitting = false;
    this.requestSubmitted = false;
    this.cdr.detectChanges();
  }
}
